import { ApAgingReport } from '@eriko/ui/src/components/reports/ApAgingReport';
import { ArAgingReport } from '@eriko/ui/src/components/reports/ArAgingReport';
import { BalanceSheetReport } from '@eriko/ui/src/components/reports/BalanceSheetReport';
import { BillDetailReport } from '@eriko/ui/src/components/reports/BillDetailReport';
import { BillReceiptReport } from '@eriko/ui/src/components/reports/BillReceiptReport';
import { CashflowForecastReport } from '@eriko/ui/src/components/reports/CashflowForecastReport';
import { ChartOfAccountsReport } from '@eriko/ui/src/components/reports/ChartOfAccountsReport';
import { Contractor1099Report } from '@eriko/ui/src/components/reports/Contractor1099Report';
import { ExpenseBreakdownReport } from '@eriko/ui/src/components/reports/ExpenseBreakdownReport';
import { ExpensesByVendorReport } from '@eriko/ui/src/components/reports/ExpensesByVendorReport';
import { FinancialRatiosReport } from '@eriko/ui/src/components/reports/FinancialRatiosReport';
import { InvoiceDetailReport } from '@eriko/ui/src/components/reports/InvoiceDetailReport';
import { InvoiceDetailView } from '@eriko/ui/src/components/reports/InvoiceDetailView';
import { KpiDashboardReport } from '@eriko/ui/src/components/reports/KpiDashboardReport';
import { OpenInvoicesReport } from '@eriko/ui/src/components/reports/OpenInvoicesReport';
import { PnlReport } from '@eriko/ui/src/components/reports/PnlReport';
import { ReconciliationListReport } from '@eriko/ui/src/components/reports/ReconciliationListReport';
import { ReportComparisonReport } from '@eriko/ui/src/components/reports/ReportComparisonReport';
import { VendorBalanceReport } from '@eriko/ui/src/components/reports/VendorBalanceReport';
import { TaxEstimateReport } from '@eriko/ui/src/components/reports/TaxEstimateReport';
import { TaxEstimateUkReport } from '@eriko/ui/src/components/reports/TaxEstimateUkReport';
import { TaxScheduleCReport } from '@eriko/ui/src/components/reports/TaxScheduleCReport';
import { Tax1099SummaryReport } from '@eriko/ui/src/components/reports/Tax1099SummaryReport';
import { TaxSa103Report } from '@eriko/ui/src/components/reports/TaxSa103Report';
import { TaxVatReturnReport } from '@eriko/ui/src/components/reports/TaxVatReturnReport';
import { TaxCis300Report } from '@eriko/ui/src/components/reports/TaxCis300Report';
import { TaxCt600Report } from '@eriko/ui/src/components/reports/TaxCt600Report';
import { GenericArtifactView } from './GenericArtifactView';
import { MonthlySummaryView } from './MonthlySummaryView';
import { SummaryTextView } from './SummaryTextView';
import { AccountDetailReport } from '@eriko/ui/src/components/reports/AccountDetailReport';
import { ContactDetailReport } from '@eriko/ui/src/components/reports/ContactDetailReport';

export function ArtifactContent({ data }: { data: Record<string, unknown> }) {
    // Profit & Loss report
    if (data.type === 'report:pnl') {
        return <PnlReport data={data} />;
    }

    // Balance Sheet report
    if (data.type === 'report:balance-sheet') {
        return <BalanceSheetReport data={data} />;
    }

    // Expense breakdown report
    if (data.type === 'report:expense-breakdown') {
        return <ExpenseBreakdownReport data={data} />;
    }

    // AR aging report
    if (data.type === 'report:ar-aging') {
        return <ArAgingReport data={data} />;
    }

    // AP aging report
    if (data.type === 'report:ap-aging') {
        return <ApAgingReport data={data} />;
    }

    // Open invoices report
    if (data.type === 'report:open-invoices') {
        return <OpenInvoicesReport data={data} />;
    }

    // Vendor balance report
    if (data.type === 'report:vendor-balance') {
        return <VendorBalanceReport data={data} />;
    }

    // Expenses by vendor report
    if (data.type === 'report:expenses-by-vendor') {
        return <ExpensesByVendorReport data={data} />;
    }

    // Chart of accounts report
    if (data.type === 'report:chart-of-accounts') {
        return <ChartOfAccountsReport data={data} />;
    }

    // 1099 contractor summary report
    if (data.type === 'report:1099') {
        return <Contractor1099Report data={data} />;
    }

    // KPI dashboard report
    if (data.type === 'report:kpi-dashboard') {
        return <KpiDashboardReport data={data} />;
    }

    // Financial ratios report
    if (data.type === 'report:financial-ratios') {
        return <FinancialRatiosReport data={data} />;
    }

    // Report comparison
    if (data.type === 'report:comparison') {
        return <ReportComparisonReport data={data} />;
    }

    // Cashflow forecast report
    if (data.type === 'report:cashflow-forecast') {
        return <CashflowForecastReport data={data} />;
    }

    // Tax estimate (US)
    if (data.type === 'tax:estimate') {
        return <TaxEstimateReport data={data} />;
    }

    // Tax estimate (UK)
    if (data.type === 'tax:estimate-uk') {
        return <TaxEstimateUkReport data={data} />;
    }

    // Schedule C (US)
    if (data.type === 'tax:schedule-c') {
        return <TaxScheduleCReport data={data} />;
    }

    // 1099 summary (US)
    if (data.type === 'tax:1099-summary') {
        return <Tax1099SummaryReport data={data} />;
    }

    // SA103 (UK)
    if (data.type === 'tax:sa103') {
        return <TaxSa103Report data={data} />;
    }

    // VAT return (UK)
    if (data.type === 'tax:vat-return') {
        return <TaxVatReturnReport data={data} />;
    }

    // CIS300 (UK)
    if (data.type === 'tax:cis300') {
        return <TaxCis300Report data={data} />;
    }

    // CT600 corporation tax (UK)
    if (data.type === 'tax:ct600') {
        return <TaxCt600Report data={data} />;
    }

    // Reconciliation list
    if (data.type === 'reconciliation-list') {
        return <ReconciliationListReport data={data} />;
    }

    // Bill detail (entity-detail:Bill payload from AI engine)
    if (data.type === 'entity-detail:Bill') {
        return <BillDetailReport data={data} />;
    }

    // Invoice entity (QBO-shaped click-to-view payload)
    if (data.entityType === 'Invoice') {
        return <InvoiceDetailView data={data} />;
    }

    // Invoice created in chat (flat create-tool artifact)
    if (data.type === 'entity-detail:Invoice') {
        return <InvoiceDetailReport data={data} />;
    }

    // Bill or Purchase entity
    if (data.entityType === 'Bill' || data.entityType === 'Purchase') {
        return <BillReceiptReport data={data} />;
    }

    // Monthly summary artifact
    if (data.type === 'monthly-summary' || 'totalRevenue' in data) {
        return <MonthlySummaryView data={data} />;
    }

    // Summary text artifact
    if (typeof data.summary === 'string') {
        return <SummaryTextView summary={data.summary} />;
    }

    if (data.entityType === 'Account') {
        return <AccountDetailReport data={data} />;
    }

    // Vendor / Customer contact detail
    if (data.entityType === 'Vendor' || data.entityType === 'Customer') {
        return <ContactDetailReport data={data} />;
    }


    // Fallback: prettified JSON
    return <GenericArtifactView data={data} />;
}
